/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Project_References_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "A project reference applies to every chat automatically. An @-mention pulls something in for one conversation only. Use references for shared, always-on cont..." |
*
* @param {Uno_Edu_Project_References_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_project_references_chip2_answer = /** @type {((inputs?: Uno_Edu_Project_References_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Project_References_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Projektreferenz gilt automatisch für jeden Chat. Eine @-Erwähnung holt etwas nur für eine Konversation hinein. Verwenden Sie Referenzen für gemeinsamen, dauerhaften Kontext und Erwähnungen für einmalige Bedürfnisse.")
	return /** @type {LocalizedString} */ ("A project reference applies to every chat automatically. An @-mention pulls something in for one conversation only. Use references for shared, always-on context and mentions for one-off needs.")
});